import { UserEventDTO } from 'generated/leaderboard-client';

import { leaderboardClient } from '@neptune/shared/core-apis-leaderboard-domain';

type UserAction = Pick<UserEventDTO, 'action' | 'actionVersion'> & {
  metadata: Record<string, unknown>;
};

class UserActions {
  private _organizationID = '';
  private _username = '';
  private _projectId = '';
  private _initialized = false;

  private buildEventDataObject({ metadata, ...action }: UserAction): UserEventDTO {
    return {
      timestampMillis: Date.now(),
      organizationID: this._organizationID,
      username: this._username,
      projectId: this._projectId,
      url: window.location.href,
      metadata: JSON.stringify(metadata),
      ...action,
    };
  }

  private logAction(action: UserAction) {
    if (!this._initialized) {
      return;
    }

    leaderboardClient.storeEvent({ event: this.buildEventDataObject(action) }).catch(() => {
      /* ignore */
    });
  }

  init() {
    this._initialized = true;
  }

  configureScope(scope: { organizationID: string; username: string; projectId: string }) {
    if (!this._initialized) {
      return;
    }

    this._projectId = scope.projectId;
    this._organizationID = scope.organizationID;
    this._username = scope.username;
  }

  logExportToPNGV1(metadata: { widgetIDs: string[]; isBulk: boolean }) {
    this.logAction({
      action: 'chart-export-to-png',
      actionVersion: 1,
      metadata,
    });
  }

  logExportToPNG(...args: Parameters<typeof this.logExportToPNGV1>) {
    this.logExportToPNGV1(...args);
  }

  logCopyToClipboardV1(metadata: { widgetIDs: string[]; isBulk: boolean }) {
    this.logAction({
      action: 'chart-copy-to-clipboard',
      actionVersion: 1,
      metadata,
    });
  }

  logCopyToClipboard(...args: Parameters<typeof this.logCopyToClipboardV1>) {
    this.logCopyToClipboardV1(...args);
  }

  logGroupByToggleV1(metadata: { mode: string }) {
    this.logAction({
      action: 'toggle-group-by-mode',
      actionVersion: 1,
      metadata,
    });
  }

  logGroupByToggle(...args: Parameters<typeof this.logGroupByToggleV1>) {
    this.logGroupByToggleV1(...args);
  }
}

export const userActionsTracker = new UserActions();
